import useRefreshTokenHandlerCustom from "../use/useRefreshTokenHandlerCustom";
import useAxiosConfigCustom from "../use/useAxiosConfigCustom";
import Box from "@mui/material/Box";

export default function ({component}) {
    const initialize = useRefreshTokenHandlerCustom();
    useAxiosConfigCustom();

    if (!initialize) return null;

    return (
        <Box height={"100dvh"}>
            {component}
        </Box>
    )
}